"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERestoreStatus = void 0;
let ERestoreStatus = exports.ERestoreStatus = /*#__PURE__*/function (ERestoreStatus) {
  ERestoreStatus["Initial"] = "initial";
  ERestoreStatus["Loading"] = "loading";
  ERestoreStatus["Succeed"] = "succeed";
  ERestoreStatus["Failed"] = "failed";
  return ERestoreStatus;
}({});